module.exports = __webpack_public_path__ + "static/media/team-2-800x800.dcfcf3b7.jpg";